import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { LOGIN_PATH } from 'constants/paths';
import SignupForm from '../ReferrerSignupForm';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import Step1 from '../WizardSteps/Step1.jsx';
import Step2 from '../WizardSteps/Step2.jsx';
import ReferrerSignupForm from '../ReferrerSignupForm/ReferrerSignupForm';

const ReferrerSignupPage = ({ emailSignup, googleLogin, onSubmitFail, referrerSignup, classes, organisation, organisations }) => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={8}>
      <ReferrerSignupForm
        validate
        onSubmit={emailSignup}
        onSubmitFail={onSubmitFail}
        steps={[
          {
            stepName: 'Detail',
            stepComponent: Step1,
            stepId: 'detail',
            index: 1
          },
          {
            stepName: 'Address',
            stepComponent: Step2,
            stepId: 'address',
            index: 2
          }
        ]}
        finishButtonClick={referrerSignup}
        organisation={organisation}
        organisations={organisations}
      />
    </GridItem>
  </GridContainer>
);

ReferrerSignupPage.propTypes = {
  classes: PropTypes.object.isRequired, // from enhancer (withStyles)
  emailSignup: PropTypes.func.isRequired, // from enhancer (withHandlers)
  referrerSignup: PropTypes.func.isRequired, // from enhancer (withHandlers)
  googleLogin: PropTypes.func.isRequired, // from enhancer (withHandlers)
  onSubmitFail: PropTypes.func.isRequired,
  organisation: PropTypes.string,
  organisations: PropTypes.array.isRequired
  // from enhancer (reduxForm)
};

export default ReferrerSignupPage;
